import {Injectable} from '@angular/core';
import {Ng2DeviceService} from "ng2-device-detector";

interface IWindow extends Window {
    webkitSpeechRecognition: any;
    SpeechRecognition: any;
}

@Injectable()
export class SpeechTextService {
    speechRecognition: any;
    deviceInfo: any;
    voices = [];
    synth;
    voice: any;

    constructor(private deviceService: Ng2DeviceService) {
        this.deviceInfo = this.deviceService.getDeviceInfo();
        if (this.deviceInfo.browser == 'chrome') {
            this.synth = window.speechSynthesis;
            this.voices = this.synth.getVoices();
            if (this.deviceInfo.browser == 'chrome') {
                this.voice = this.voices[0];
            } else if (this.deviceInfo.browser == 'safari') {
                this.voice = this.voices[29];
            } else {
                this.voice = this.voices[0];
            }
        }

    }

    voiceSpeech(texto): void {
        if (this.deviceInfo.browser == 'chrome') {
            let utterThis = new SpeechSynthesisUtterance(texto);
            utterThis.voice = this.voice;
            utterThis.pitch = 1;
            utterThis.rate = 1;
            this.synth.speak(utterThis);

            utterThis.onpause = function (event) {
                console.log("pausado");
            }
        }
    }

}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/recursos/servicio/speech-text.service.ts